/**
 *
 * Product Tags
 *
 */
import React, { memo } from 'react';
import { DataTable } from './components/view-list';
import { Card, CardContent } from 'app/components/ui/card';
import { Tag } from 'lucide-react';

interface Props { }

export const ProductTags = memo((props: Props) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-10 h-10 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center">
              <Tag className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
                Product Tags
              </h1>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                Organize your products with tags for better categorization
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <Card className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm border border-white/20 dark:border-gray-700/50">
          <CardContent className="p-0">
            <DataTable />
          </CardContent>
        </Card>
      </div>
    </div>
  );
});
